import { Reducer } from 'redux';
import { connectRouter } from 'connected-react-router';
import { partialReducers } from 'src/utils/partialReducers';
import { RootState } from 'src/state/RootState';
import { searchReducer } from 'src/reducers/searchReducer';
import { HISTORY } from 'src/constants/history';
import { suggestReducer } from 'src/reducers/suggestReducer';
import { queryReducer } from 'src/reducers/queryReducer';

export const rootReducer = partialReducers<RootState>({
    router: connectRouter(HISTORY),
    search: searchReducer,
    suggest: suggestReducer,
    query: queryReducer,
}) as Reducer<RootState>;
